// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'

const pl = {
  paddingLeft: '3px',
}

const FormatFrequencyHeader = () => (
  <div className={'display-flex flex-direction-row flex-wrap-nowrap justify-content-end'}>
    <span>{'Frequency'}</span>
    <small style={pl}>{'(MHz)'}</small>
  </div>
)

export default FormatFrequencyHeader
